import AdminCRUD from "@/components/admin/AdminCRUD";

const empty = { image_path: "", caption: "", date: "", category: "events", event_name: "", order: 0 };
const fields = [
  { name: "image_path", label: "Photo", type: "image", required: true, help: "JPG/PNG/WebP (max 10MB)." },
  { name: "caption", label: "Caption", type: "text", placeholder: "What's happening in this photo?" },
  { name: "date", label: "Date", type: "text", placeholder: "e.g. September 12, 2021" },
  {
    name: "category", label: "Category", type: "select", required: true,
    options: [
      { value: "events", label: "Events" },
      { value: "awareness", label: "Awareness" },
      { value: "memory", label: "In Loving Memory" },
    ],
  },
  { name: "event_name", label: "Event group name", type: "text", placeholder: "e.g. Recovery Connections Golf Fundraiser", help: "Used to group photos under the same event in the gallery." },
];

export default function AdminGallery() {
  return (
    <AdminCRUD
      title="Gallery"
      description="Photos shown on the public Gallery page. Categorize + group by event so visitors can filter."
      endpoint="gallery"
      emptyItem={empty}
      fields={fields}
      itemLabel={(g) => g.caption || "(no caption)"}
      itemSubtitle={(g) => `${g.category}${g.event_name ? " · " + g.event_name : ""}${g.date ? " · " + g.date : ""}`}
    />
  );
}
